// rem 适配方案 - 基于 750px 设计稿，1rem = 100px
function setRemBase() {
  const baseSize = 100; // 750px 设计稿，1rem = 100px
  const docEl = document.documentElement;
  const clientWidth = docEl.clientWidth;

  if (!clientWidth) return;

  // 计算根字体大小：当前屏幕宽度 / 设计稿宽度 * 基准值
  const fontSize = (clientWidth / 750) * baseSize;

  // 设置最小和最大字体大小，避免在极小或极大屏幕上显示异常
  const minFontSize = 12; // 最小字体大小
  const maxFontSize = 100; // 最大字体大小

  docEl.style.fontSize =
    Math.max(minFontSize, Math.min(fontSize, maxFontSize)) + "px";
}

// 页面加载完成后设置
setRemBase();

// 监听窗口大小变化
window.addEventListener("resize", setRemBase);

// 监听页面显示（解决某些浏览器切换标签页后字体大小异常的问题）
document.addEventListener("DOMContentLoaded", setRemBase);
window.addEventListener("pageshow", setRemBase);

export default setRemBase;
